var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('segment-new-form')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }